// Libraries
import { Stack } from "@mui/material";
import { useMemo } from "react";

// Context
import { useReconciliationSection } from "@DataPages/context/inventory/ReconciliationSectionContext";

// Components
import FilterButtonReconciliation from "@DataPages/components/Inventory/Layout/Reconciliation/FilterButtonReconciliation.tsx";

// Helpers
import { getVehicleAmount } from "../../helpers/reconciliation";

type TMultiSelectFilterButtonsProps = {
	filterOptions: string[];
};

export default function MultiSelectFilterButtonsReconciliation(props: Readonly<TMultiSelectFilterButtonsProps>) {
	const { filterOptions } = props;

	const { unFilteredData, filterValues, setFilterValues } = useReconciliationSection();

	const options = useMemo(() => {
		return filterOptions.map((filter) => {
			const vehicleAmount = getVehicleAmount(filter, unFilteredData);
			return {
				label: filter,
				isDisabled: !vehicleAmount,
				selected: filterValues.includes(filter),
				vehicleAmount,
			};
		});
	}, [filterOptions, unFilteredData, filterValues]);

	/********************************************* HANDLERS ************************************************/
	function handleToggleSelected(label: string) {
		setFilterValues((prev) => (prev.includes(label) ? prev.filter((v) => v !== label) : [...prev, label]));
	}

	return (
		<Stack direction="row" spacing={3} component={"menu"} role={"menubar"}>
			{options.map((option) => {
				return (
					<FilterButtonReconciliation
						key={option.label}
						{...option}
						onToggleSelected={() => {
							handleToggleSelected(option.label);
						}}
					/>
				);
			})}
		</Stack>
	);
}
